import { Box, Stack, Text } from "@chakra-ui/react";
import { Container } from "components/Container";
import { useRef } from "react";
import type { SbEditableComponentProps } from "types/storyblok";
import { trackEcommerceEvent } from "utils/tracking";
import { useElementIntersectionOnce } from "hooks";
import type { AhPlusPricingPlansProps } from "./AhPlusPricingPlans.d";
import { PRICING_PLANS_ANCHOR } from "./config";
import { PlanBox } from "./PlanBox/PlanBox";
import { useGetViewItemTrackingEvent } from "./trackingUtils";

export const AhPlusPricingPlans = ({
  bottomText,
  horizontalPaddingDesktop,
  horizontalPaddingMobile,
  verticalPaddingDesktop,
  verticalPaddingMobile,
  sbEditable,
  cards,
}: SbEditableComponentProps<AhPlusPricingPlansProps>) => {
  const viewItemTrackingEvent = useGetViewItemTrackingEvent();
  const sectionRef = useRef<HTMLDivElement>(null);
  const trackingEventHandler = () => trackEcommerceEvent(viewItemTrackingEvent);
  useElementIntersectionOnce(sectionRef, trackingEventHandler);

  return (
    <Box
      {...sbEditable}
      bg="primary.900"
      id={PRICING_PLANS_ANCHOR}
      py={{ base: verticalPaddingMobile, lg: verticalPaddingDesktop }}
      px={{ base: horizontalPaddingMobile, lg: horizontalPaddingDesktop }}
    >
      <Container>
        <Stack
          spacing={{ base: 8, md: 4, lg: 8 }}
          direction={{ base: "column", md: "row" }}
          justify="center"
          align="stretch"
          ref={sectionRef}
        >
          {cards?.map(({ content, planType, _uid }) => (
            <PlanBox key={_uid} content={content} planType={planType} />
          ))}
        </Stack>
        <Text px={8} color="white" fontSize="md" textAlign="center" mt={{ base: 12, md: 10 }}>
          {bottomText}
        </Text>
      </Container>
    </Box>
  );
};
